import * as actionTypes from './actionTypes';

export const setAvailableFeatures=(availableFeatures)=>{
    return{
        type: actionTypes.SET_AVAILABLE_FEATURES,
        availableFeatures: availableFeatures
    }
}
